import { JobsGateDialogs } from "domains/hire/containers/JobsGateDialogs";
import { hireNotReadyAtom } from "domains/hire/hireNotReady";
import { type HireNotReadyReason, hireGateFor } from "domains/hire/hireReadiness";
import { useCanUpdatePaymentMethod } from "domains/home/containers/UpdatePaymentMethod";
import { useAtom } from "jotai";
import { useActiveLocation } from "services/locationOrgContext";

const NotReadyGate = ({ reason, onClose }: { reason: HireNotReadyReason; onClose: () => void }) => {
  const [location] = useActiveLocation();
  const canUpdatePayment = useCanUpdatePaymentMethod();
  const gate = hireGateFor({ ready: false, reason }, { canUpdatePayment });
  return <JobsGateDialogs locationId={location.id} open={gate} onClose={onClose} />;
};

/**
 * The fallback for a Hire action the API refused as `hire_location_not_ready` on a page that hadn't loaded
 * `hire_readiness`: the same gate the page would have opened on click. Mounted once in the Hire layout, and only
 * reads the active location once there is a refusal to explain.
 */
export const HireNotReadyDialog = () => {
  const [reason, setReason] = useAtom(hireNotReadyAtom);
  return reason && <NotReadyGate reason={reason} onClose={() => setReason(null)} />;
};
